import { Modal } from './lib/modal.ts';

const DOM = {};
const mediaQuery = window.matchMedia('(max-width: 768px)');
let isFixedNav = false;
let isBottomBar = false;
let prevY;

const cacheDOM = () => {
    DOM.nav = document.querySelector('.nav');
    DOM.banner = document.querySelector('.banner');
    DOM.homeBottomBar = document.querySelector('.home-bottom-bar');
};

const toggleFixedNav = () => {
    if (!isFixedNav) {
        DOM.nav.classList.add('nav--fixed');
        DOM.nav.classList.add('nav--opened');
        isFixedNav = true;
    } else {
        DOM.nav.classList.remove('nav--opened');
        DOM.nav.classList.add('nav--closed');
        setTimeout(() => {
            DOM.nav.classList.remove('nav--fixed');
            DOM.nav.classList.remove('nav--closed');
        }, 100);
        isFixedNav = false;
    }
};

const toggleBottomBar = () => {
    if (!isBottomBar) {
        DOM.homeBottomBar.classList.add('home-bottom-bar--opened');
        isBottomBar = true;
    } else {
        DOM.homeBottomBar.classList.remove('home-bottom-bar--opened');
        isBottomBar = false;
    }
};

const toggleFixedElements = () => {
    const scrollPosition = DOM.banner.getBoundingClientRect().top * -1;
    const bannerHeight = DOM.banner.getBoundingClientRect().height;
    const showPoint = bannerHeight * 0.75;

    if (scrollPosition > showPoint) {
        if (mediaQuery.matches) {
            if (!isFixedNav && prevY > scrollPosition) {
                toggleFixedNav();
            } else if (
                isFixedNav &&
                prevY < scrollPosition &&
                !Modal.isOpen()
            ) {
                toggleFixedNav();
            }
            if (!isBottomBar) {
                toggleBottomBar();
            }
        } else {
            if (!isFixedNav) {
                toggleFixedNav();
            }
            if (isBottomBar) {
                toggleBottomBar();
            }
        }
    } else {
        if (isFixedNav) {
            toggleFixedNav();
        }
        if (isBottomBar) {
            toggleBottomBar();
        }
    }

    prevY = scrollPosition;
};

const toggleNavModal = () => {
    const scrollPosition = DOM.banner.getBoundingClientRect().top * -1;
    const showPoint = DOM.nav.getBoundingClientRect().height / 2;

    if (scrollPosition > showPoint && mediaQuery.matches) {
        if (
            !DOM.nav.classList.contains('nav--fixed') &&
            !DOM.nav.classList.contains('nav--opened')
        ) {
            DOM.nav.classList.add('nav--fixed');
            DOM.nav.classList.add('nav--opened');
        }
    }
};

const handleResize = () => {
    toggleFixedElements();

    if (isBottomBar && !mediaQuery.matches) {
        toggleBottomBar();
    }
};

const bindEvents = () => {
    document.addEventListener('scroll', toggleFixedElements);
    window.addEventListener('resize', handleResize);
};

const init = () => {
    cacheDOM();
    if (DOM.nav && DOM.banner) {
        bindEvents();
    }
};

const fixedElements = { init, toggleNavModal };
export default fixedElements;
